import React, { useEffect, useState } from "react";
import { Col, Container, Row, Modal, Button } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import Layout from "../components/Layout";
import Form from "react-bootstrap/Form";
import { useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { getMedallions } from "../redux/actions/medallion";
import { getProfile, updateProfile, uploadFile } from "../redux/actions/profile";
import { updateUserData } from "../redux/reducers/authSlice";
import { toast } from "react-toastify";
import { MEDALLION_TYPES } from "../constants/medallionTypes";
import TributeSection from "../components/TributeSection";
import PhoneNumberField from "../components/PhoneNumberField";


export default function ProfileView() {
  const [scrolled, setScrolled] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [profile, setProfile] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      if (scrollTop > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      const response = await dispatch(getProfile()).unwrap();
      setProfile(response.data);
    } catch (error) {
      console.error('Error fetching profile:', error);
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
    setShowLogoutModal(false);
  };

  const [profileImage, setProfileImage] = useState(null);
  const [profileImagePreview, setProfileImagePreview] = useState(null);


  const uploadImage = async (file) => {
    const formData = new FormData();
    formData.append("image", file);
    const response = await dispatch(uploadFile(formData)).unwrap();
    return response.data?.image;
  };

  const handleProfileImageChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfileImage(file);
      const reader = new FileReader();
      reader.onload = (e) => setProfileImagePreview(e.target.result);
      reader.readAsDataURL(file);
      
      try {
        const profileImageUrl = await uploadImage(file);
        const response = await dispatch(
          updateProfile({ profile_image: profileImageUrl })
        ).unwrap();
        
        setProfile((prev) => ({
          ...prev,
          profile_image: profileImageUrl,
        }));
        
        // Update Redux user state
        dispatch(updateUserData({ profile_image: profileImageUrl }));
        
        toast.success("Profile image updated successfully!");
        setProfileImage(null);
        setProfileImagePreview(null);
      } catch (error) {
        console.error('Error uploading profile image:', error);
        toast.error('Failed to update profile image');
      }
    }
  };

  return (
    <Layout>
      <section className="profile-banner-sec">
        <Container></Container>
      </section>
      <section className="profile-sec-content">
        <Container>
          <div className="profile-sec-data">
            <img
              src={
                profileImagePreview ||
                profile?.profile_image ||
                require("../assets/images/sarahjohnson.png")
              }
            />
            <div
              className="edit-icon"
              onClick={() => document.getElementById("profileInput").click()}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path
                  d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <input
              id="profileInput"
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleProfileImageChange}
            />
            <h2>{profile?.name}</h2>

            <div className="profile-view-data">
              <Formik
                initialValues={{
                  email: profile?.email || '',
                  phone_number: `${profile?.country_code || ''}${profile?.phone_number || ''}`
                }}
                enableReinitialize
                onSubmit={() => { }}
              >
                {() => (
                  <Form>
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="45"
                        height="46"
                        viewBox="0 0 45 46"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_612_1878)">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M42.0469 10.5915L24.2916 25.622C23.787 26.0493 23.1524 26.2831 22.4972 26.2831C21.842 26.2831 21.2073 26.0493 20.7028 25.622L2.95594 10.5915C2.86071 10.8845 2.81228 11.1913 2.8125 11.5V34.5C2.8125 35.2625 3.10882 35.9938 3.63626 36.5329C4.16371 37.0721 4.87908 37.375 5.625 37.375H39.375C40.1209 37.375 40.8363 37.0721 41.3637 36.5329C41.8912 35.9938 42.1875 35.2625 42.1875 34.5V11.5C42.1886 11.1914 42.1411 10.8847 42.0469 10.5915ZM5.625 5.75H39.375C40.8668 5.75 42.2976 6.3558 43.3525 7.43414C44.4074 8.51247 45 9.97501 45 11.5V34.5C45 36.025 44.4074 37.4875 43.3525 38.5659C42.2976 39.6442 40.8668 40.25 39.375 40.25H5.625C4.13316 40.25 2.70242 39.6442 1.64752 38.5659C0.592632 37.4875 0 36.025 0 34.5V11.5C0 9.97501 0.592632 8.51247 1.64752 7.43414C2.70242 6.3558 4.13316 5.75 5.625 5.75ZM5.03437 8.625L20.7169 21.8586C21.2191 22.2827 21.8499 22.5154 22.5013 22.517C23.1527 22.5185 23.7845 22.2889 24.2887 21.8673L40.1287 8.625H5.03437Z"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_612_1878">
                            <rect width="45" height="46" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <input type="email" value={profile?.email} readOnly placeholder="Email" />
                    </div>
                    <PhoneNumberField
                      name="phone_number"
                      label="Phone"
                      placeholder="+44"
                      defaultCountry="GB"
                      readOnly
                    />
                    <button type="button" onClick={() => setShowLogoutModal(true)} >Log out</button>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </Container>
      </section>

      <Modal className="commn-modal-css" show={showLogoutModal} onHide={() => setShowLogoutModal(false)} centered>
        <Modal.Header className="border-0"></Modal.Header>
        <Modal.Body className="pt-0">
          <h2>Confirm Logout</h2>
          <p>Are you sure you want to logout?</p>
          <div className="d-flex justify-content-center gap-2 comnn-modal-action">
            <button className="outline" onClick={() => setShowLogoutModal(false)}>
              Cancel
            </button>
            <button className="fill" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </Layout>
  );
}
